module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/icon-outer-5f338327b4fcb224927ab9c62cc3a9d5.svg";